import * as React from "react"
import {connect} from "react-redux"
import {bindActionCreators} from "redux"

import Body from "./components/sections/com_body"
import Header from "./components/sections/com_header"
import Overlay from "./components/sections/com_overlay"

import {
    setFilteredData,
    fetchAllTechFamilies,
    fetchAllComFamilies,
    setRole,
    setSelectedSupplier,
    setManagedSupplierList,
    changeSelectedSupplier,
    fetchBusinessUnit,
    fetchTranslations,
    repairCaratech,
    repairTopRefs,
    repairColor,
    initialiseProductForm,
    fetchIsgUrls,
} from "../core/actions"
import {Roles} from "../utils"
import {LocalStorageKeys} from "../utils/local-storage-keys"
import {getActions} from "./product-form/_actions"
import {ISupplierInfo, permanentFormIds} from "../models"
import {$getMaintenanceState} from "../core/requests"
import {Route, Switch} from "react-router-dom"
import Loading from "./components/com_loading"
import MaintenancePage from "./maintenance"
import MaintenanceManagement from "./maintenance-management"

export interface IAppProps {
    // lang: string
    role: Roles
    managedSupplierList: ISupplierInfo[]
    initialiseFunctions: Array<() => void>
    functions: {
        setRole(role: string): void
        setFilteredData(data: object, filter: string, treeName: string): void
        setSelectedSupplier(supplierName: ISupplierInfo): void
        setManagedSupplierList(managedSupplierList: ISupplierInfo[]): void
        changeSelectedSupplier(supplierName: ISupplierInfo): void
    }
    repairCaratech: () => void
    repairTopRefs: () => void
    repairColor: () => void
}

const App = (props: IAppProps) => {
    const [initialized, setInitialized] = React.useState(false)
    const [isMaintenanceOn, setIsMaintenanceOn] = React.useState(false)

    React.useEffect(() => {
        props.functions.setRole(props.role)
        props.functions.setManagedSupplierList(props.managedSupplierList)
        const stored = localStorage.getItem(LocalStorageKeys.SELECTED_SUPPLIER)
        if (stored) {
            const found = props.managedSupplierList.find(x => x.supplierName == stored)
            if (!found) {
                window.localStorage.clear()
                props.functions.changeSelectedSupplier(props.managedSupplierList[0])
            } else {
                props.functions.setSelectedSupplier(found)
            }
        } else {
            props.functions.changeSelectedSupplier(props.managedSupplierList[0])
        }
        initialize(props.initialiseFunctions)

        $getMaintenanceState()
            .then((res: boolean) => setIsMaintenanceOn(res))
            // The error is displayed by $myFetch: start the application anyway instead of loading forever.
            .catch(() => setIsMaintenanceOn(false))
            .finally(() => setInitialized(true))
    }, [])

    const initialize = (functions: Array<() => void>) => {
        functions.forEach((func) => func())
        // Hidden global repair tools: market leaders only (the API enforces it as well).
        if (props.role !== Roles.MARKET_LEADER) {
            return
        }
        if (window.location.pathname.toLocaleLowerCase() === "/repairtopref") {
            props.repairTopRefs()
        }
        if (window.location.pathname.toLocaleLowerCase() === "/repaircaratech") {
            props.repairCaratech()
        }
        if (window.location.pathname.toLocaleLowerCase() === "/repaircolor") {
            props.repairColor()
        }
    }

    if (!initialized) {
        return <Loading/>
    }

    const MaintenanceManager = () => (
        <MaintenanceManagement isOnMaintenance={isMaintenanceOn}/>
    )

    return (
        <Switch>
            {props.role === Roles.MARKET_LEADER && (
                <Route exact path="/maintenance" component={MaintenanceManager}/>
            )}
            {isMaintenanceOn && (
                <Route path="/:filter?" component={MaintenancePage}/>
            )}
            {!isMaintenanceOn && <Route path="/:filter?" render={AppCore}/>}
        </Switch>
    )
}

const AppCore = () => (
    <div className="App">
        <Header/>
        <Overlay/>
        <Body/>
    </div>
)

const mapDispatchToProps = (dispatch: any) => {
    const productFormActions = getActions(dispatch)
    return {
        functions: bindActionCreators(
            {
                setFilteredData,
                setRole,
                setSelectedSupplier,
                setManagedSupplierList,
                changeSelectedSupplier,
            },
            dispatch
        ),
        initialiseFunctions: [
            () => dispatch(fetchAllTechFamilies()),
            () => dispatch(fetchAllComFamilies()),
            () => dispatch(initialiseProductForm()),
            () => dispatch(fetchBusinessUnit()),
            () => dispatch(fetchIsgUrls()),
            () => dispatch(fetchTranslations()),
            () => productFormActions._initFormId(permanentFormIds.NEW_PRODUCT),
            () => productFormActions._initFormId(permanentFormIds.MULTI_MODIF),
        ],
        repairCaratech: () => dispatch(repairCaratech()),
        repairTopRefs: () => dispatch(repairTopRefs()),
        repairColor: () => dispatch(repairColor()),
    }
}

// const mapStateToProps = (state: any) => ({
//   lang: state.lang
// })

export default connect(
    // mapStateToProps,
    undefined,
    mapDispatchToProps
)(App)
